import { getRgObjectsOfType, RG_TYPE } from "@project-rouge/rg-core";
import { createFacadeFromBoundary } from "@project-rouge/rg-three";
import { getActiveBuildings } from "./index183.js";
const pipeAddFacade = ([parent, { buildingIds, aggProps }]) => {
  var _a;
  const dataset = aggProps.dataset;
  const zones = getRgObjectsOfType(parent, RG_TYPE.Zone);
  for (const zone of zones) {
    const buildings = getActiveBuildings(zone, aggProps);
    const facadeModId = ((_a = aggProps.zones[zone.uuid]) == null ? void 0 : _a.facadeId) ?? dataset.modulousIds.facadeId;
    for (const building of buildings) {
      if (buildingIds && !buildingIds.includes(building.uuid))
        continue;
      createFacadeFromBoundary({ building, rvDataList: dataset.rvData, facadeModId });
    }
  }
  return [parent, void 0];
};
export {
  pipeAddFacade
};
//# sourceMappingURL=index89.js.map
